import "./ArchiveProductTemplate.module.css"
import HeaderPrincipale from "@/reusable_sections/Header"
import PageTitleAndBreadcrumbsSection from "./sections/PageTitleAndBreadcrumbsSection"
import ProductGridAndPaginationSection from "./sections/ProductGridAndPaginationSection"
import FooterInformativo from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <HeaderPrincipale />
      <PageTitleAndBreadcrumbsSection />
      <ProductGridAndPaginationSection />
      <FooterInformativo />
    </div>
  )
}
